<template>
<div>
    <div class="container">
        <el-page-header class="page-header" @back="goBack" content="自拟组方确认"></el-page-header>
        <AreaHeader class="area-header-one" title="基本信息"></AreaHeader>
        <ul class="basic-info" v-if="consultInfo">
            <li><b>姓名：</b>{{consultInfo.name}}</li>
            <li><b>性别：</b>{{consultInfo.sex == '1'?'男':'女'}}</li>
            <li><b>电话：</b>{{consultInfo.phoneNo}}</li>
            <li><b>出生日期：</b>{{consultInfo.birthday}}</li>
            <li><b>常住地址：</b>{{consultInfo.liveArea}}</li>
            <li><b>出生地址：</b>{{consultInfo.birthArea}}</li>
            <li v-if="consultInfo.useDate"><b>开始服药时间：</b>{{consultInfo.useDate}}</li>
            <li v-if="consultInfo.useDays"><b>服药天数：</b>{{consultInfo.useDays}}</li>
        </ul>

        <AreaHeader class="area-header" title="症状信息"></AreaHeader>
        <table border="1" class="basic-info basic-table">
            <tr class="table-rows" v-for="(item,index) in basicTableArray">
                <td v-if="index == 0" :rowspan="basicTableArray.length">基本情况</td>
                <td v-if="item.value.length > 0">{{item.key}}</td>
                <td v-if="item.value.length > 0">{{item.value}}</td>
            </tr>
            <tr class="table-rows" v-for="(item1,index) in shangjiaoTableArray" v-if="hasShangJiao">
                <td v-if="index == 0" :rowspan="shangjiaoTableArray.length">上焦</td>
                <td v-if="item1.value">{{item1.key}}</td>
                <td v-if="item1.value">{{item1.value.toString()}}</td>
            </tr>
            <tr class="table-rows" v-for="(item2,index) in zhongjiaoTableArray" v-if="hasZhongJiao">
                <td v-if="index == 0" :rowspan="zhongjiaoTableArray.length">中焦</td>
                <td v-if="item2.value">{{item2.key}}</td>
                <td v-if="item2.value">{{item2.value.toString()}}</td>
            </tr>
            <tr class="table-rows" v-for="(item3,index) in xiajiaoTableArray" v-if="hasXiaJiao">
                <td v-if="index == 0" :rowspan="xiajiaoTableArray.length">下焦</td>
                <td v-if="item3.value">{{item3.key}}</td>
                <td v-if="item3.value">{{item3.value.toString()}}</td>
            </tr>
        </table>
        <AreaHeader class="area-header-one" title="自拟组方信息"></AreaHeader>
        <ul class="basic-info" v-if="consultInfo">
            <li><b>诊断结果：</b>{{diagnoseResult}}</li>
            <li><b>服药时间：</b>{{takeMedTime}}</li>
            <!-- <li><b>开始日期：</b>{{tablePrescription[0].startDate}}</li>
            <li><b>结束日期：</b>{{tablePrescription[0].endDate}}</li> -->
        </ul>
        <el-table :data="selectDrugList" :span-method="arraySpanMethod" style="width:97%; padding-left: 2%;margin-top: 20px;" :row-class-name="tableRowClassName">
          <el-table-column prop="index" label="序号" width="180">
          </el-table-column>
          <el-table-column prop="label" label="药品名称" >
          </el-table-column>
          <el-table-column prop="weight" label="重量(g)" width="120">
          </el-table-column>
          <el-table-column  label="饮片重量(g)" width="120">
            <template slot-scope="scope">
              {{Math.ceil(scope.row.weight*scope.row.piecesWeight)}}
            </template>
          </el-table-column>
        </el-table>
            <el-tab-pane class="tab-pane" :label="pane.title" :name="index.toString()" v-for="(pane,index) in tablePrescription" :key="pane.index">
                <table border="1" class="basic-info" style="margin-left: 20px;">
                    <tr class="table-header">
                        <td>序号</td>
                        <td>药品</td>
                        <td>重量（克）</td>
                        <td>序号</td>
                        <td>药品</td>
                        <td>重量（克）</td>
                    </tr>
                    <tr class="table-rows" v-for="item in pane.options">
                        <td style="width: 8%;">
                          <span class="span-index" v-show="item.key">{{item.index}}</span>
                        </td>
                        <td style="width: 30%;">
                          <div class="item-row" v-show="item.key">
                            <span style="width: 100%; padding-left: 10%; text-align: left;">{{item.key}}</span>
                            <el-button @click="drugChangeClick(pane,item,0)" style="width: 62px;height:30px; border-color: #156098;color: #156098;display: none;" size="small">更换</el-button>
                          </div>
                        </td>
                        <td style="width: 12%;">
                          <div class="item-row" v-show="item.key">
                            <span style="width: 100%; text-align: center;">{{item.value}}g</span>
                            <el-button  @click="drugWeightClick(pane,item,0)" style="width: 62px;height:30px; border-color: #156098;color: #156098;display: none;" size="small">更换</el-button>
                          </div>
                        <td style="width: 8%;"><span v-show="item.key1" class="span-index">{{item.index1}}</span></td>
                        <td style="width: 30%;">
                          <div class="item-row" v-show="item.key1">
                            <span style="width: 100%; padding-left: 10%; text-align: left;">{{item.key1}}</span>
                            <el-button @click="drugChangeClick(pane,item,1)" style="width: 25%;height:30px; border-color: #156098;color: #156098;display: none;" size="small">更换</el-button>
                          </div>
                        </td>
                        <td style="width: 12%;">
                          <div class="item-row" v-show="item.key1">
                            <span style="width: 100%; text-align: center;">{{item.value1}}g</span>
                            <el-button @click="drugWeightClick(pane,item,1)" style="width: 62px;height:30px; border-color: #156098;color: #156098;display: none;" size="small">更换</el-button>
                          </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="table-footer-td" colspan="6"><b>*</b>总计：<b>{{pane.count}}</b>味，<b>{{pane.totalWeight}}</b>克；<b v-show="pane.charge != 0" style="color: black;">参考药价：</b><b v-show="pane.charge != 0">{{pane.charge}}</b><b v-show="pane.charge != 0" style="color: black;">元/副</b></td>
                    </tr>
                    <tr class="table-footer" >
                        <td class="table-footer-td" colspan="6"><b>*</b>有效使用期：{{pane.startDate}} ~ {{pane.endDate}}</td>
                    </tr>
                </table>
            </el-tab-pane>
        </el-tabs>
        <el-button class="btn-confirm" type="primary" @click="submit">创建自拟方订单</el-button>
    </div>
</div>
</template>

<script>
import AreaHeader from '@/components/widgets/area-header.vue'
import WJTRadio from '@/components/widgets/wjt-radio.vue'
export default {
    components:{
        AreaHeader,
        WJTRadio
    },
    data(){
        return{
            tabActive:'0',
            prescriptions:[],
            tablePrescription:[],
            changeDrugList:[],
            visible:false,
            dialogDrugVisible:false,
            dialogWeightVisible:false,
            currentDrug:'',
            currentWeight:'',
            currentItem:{},
            flag:0,
            basicTableArray:[],
            shangjiaoTableArray:[],
            zhongjiaoTableArray:[],
            xiajiaoTableArray:[],
            consultInfo:{},
            hasShangJiao:false,
            hasZhongJiao:false,
            hasXiaJiao:false,
            visitRecordId:"",
            diagnoseResult: '',
            takeMedTime: "",
            selectDrugList:[]
        }
    },
    mounted(){
      this.visitRecordId = this.$route.query.visitRecordId
      console.log("visitRecordId: "+this.visitRecordId)
      this.consultInfo = JSON.parse(sessionStorage.getItem('consultInfo')).contact
      this.consultInfo.useDate = JSON.parse(sessionStorage.getItem('consultInfo')).useDate
      this.consultInfo.useDays = JSON.parse(sessionStorage.getItem('consultInfo')).useDays
      this.submitData = JSON.parse(sessionStorage.getItem("submitData"))
      this.basicTableArray = this.basicTableArray.concat(this.submitData.basic_array)
      this.basicTableArray = this.basicTableArray.concat(this.submitData.basic_enter_array)
      this.basicTableArray = this.basicTableArray.concat(this.submitData.maixiang_array)
      this.shangjiaoTableArray = this.submitData.shangjiao_array
      this.zhongjiaoTableArray = this.submitData.zhongjiao_array
      this.xiajiaoTableArray = this.xiajiao_array
      this.selectDrugList = JSON.parse(sessionStorage.getItem('selectDrugList'))
      var handMakeInfo = JSON.parse(sessionStorage.getItem('handMakeInfo'))
      this.diagnoseResult = handMakeInfo.diagnoseResult
      this.takeMedTime = handMakeInfo.takeMedTime
      this.submitData.shangjiao_array.forEach(function (element) {
          if(element.value.length > 0){
            that.hasShangJiao = true
          }
      })
      this.submitData.zhongjiao_array.forEach(function (element) {
          if(element.value.length > 0){
            that.hasZhongJiao = true
          }
      })
      this.submitData.xiajiao_array.forEach(function (element) {
          if(element.value.length > 0){
            that.hasXiaJiao = true
          }
      })
      this.patientId = this.consultInfo.patientId
    },
    methods:{
        goBack(){
            this.$router.go(-1)
        },
        arraySpanMethod({ row, column, rowIndex, columnIndex }) {
          if (rowIndex == this.selectDrugList.length-1 && columnIndex == 0) {
            return [1, 4];
          }
        },
        tableRowClassName({row, rowIndex}) {
          if (rowIndex == this.selectDrugList.length - 1) {
            return 'total-row';
          }
          return '';
        },
        submit(){
          var newShangjiao_array = this.submitData.shangjiao_array.map((obj,index)=>{
              obj.value = this.submitData.shangjiao_array[index].value.toString()
              return obj
          })
          var newZhongjiao_array = this.submitData.zhongjiao_array.map((obj,index)=>{
              obj.value = this.submitData.zhongjiao_array[index].value.toString()
              return obj
          })
          var newXiajiao_array = this.submitData.xiajiao_array.map((obj,index)=>{
              obj.value = this.submitData.xiajiao_array[index].value.toString()
              return obj
          })
          var newSubmitData = {}
          newSubmitData.basic_array = this.submitData.basic_array
          newSubmitData.basic_enter_array = this.submitData.basic_enter_array
          newSubmitData.maixiang_array = this.submitData.maixiang_array
          newSubmitData.shangjiao_array = newShangjiao_array
          newSubmitData.zhongjiao_array = newZhongjiao_array
          newSubmitData.xiajiao_array = newXiajiao_array
          var prescriptionList = []
          console.log(this.selectDrugList)
          this.selectDrugList.forEach((item) => {
            var name = item.label
            if(name && name.length > 0){
              prescriptionList.push({
                key:name,
                value:item.weight,
                index:item.index
              })
            }
          })
          var prescriptionBody = {
            disease: this.diagnoseResult,
            prescriptionList: prescriptionList,
            take_time: this.takeMedTime,
            total: 0
          }
          var params = {
              patientId:this.consultInfo.patientId,
              toDoDay:this.consultInfo.useDate,
              takeDays:this.consultInfo.useDays,
              inquiryInfo:newSubmitData,
              prescriptionBody:prescriptionBody
          }
          this.wjtHttp.post(this, '/api/health/v2/prescription/self/image',params, true, (res) => {
            var data = res.data
            if (data.code == 200) {
              this.prescriptions = data.data.prescription.prescriptionInfos
              var consultInfo = data.data.prescription.patient
              consultInfo.useDate = data.data.prescription.startDate
              consultInfo.useDays = data.data.prescription.takeDays
              this.basicTableArray = this.basicTableArray.concat(data.data.prescription.inquiryInfo.basic_array)
              this.basicTableArray = this.basicTableArray.concat(data.data.prescription.inquiryInfo.basic_enter_array)
              this.basicTableArray = this.basicTableArray.concat(data.data.prescription.inquiryInfo.maixiang_array)
              var shangjiaoTableArray = data.data.prescription.inquiryInfo.shangjiao_array
              var zhongjiaoTableArray = data.data.prescription.inquiryInfo.zhongjiao_array
              var xiajiaoTableArray = data.data.prescription.inquiryInfo.xiajiao_array

              sessionStorage.setItem('consultInfo',JSON.stringify(consultInfo))
              sessionStorage.setItem('basicTable',JSON.stringify(this.basicTableArray))
              sessionStorage.setItem('shangjiaoTableArray',JSON.stringify(shangjiaoTableArray))
              sessionStorage.setItem('zhongjiaoTableArray',JSON.stringify(zhongjiaoTableArray))
              sessionStorage.setItem('xiajiaoTableArray',JSON.stringify(xiajiaoTableArray))
              this.generateTableData()
              sessionStorage.setItem('tablePrescription',JSON.stringify(this.tablePrescription))
              sessionStorage.setItem('images',JSON.stringify(data.data.images))
              this.$router.replace({
                path:'/handmadePrescriptionDetails',
                query:{
                    visitRecordId:data.data.images[0].visitRecordId,
                  }
              })
            } else {
              this.$message({
                message: (data.msg && data.msg.length > 0) ? data.msg : '提交自拟组方异常',
                type: 'error'
              })
            }
          }, (err) => {
            console.log(err)
          })
        },
        generateTableData(){
          this.tablePrescription = []
          for (var i = 0; i < this.prescriptions.length; i++){
            var table_data_item = {}
            var item = this.prescriptions[i]
            table_data_item.count = item.count
            table_data_item.charge = item.charge
            table_data_item.totalWeight = item.totalWeight
            table_data_item.startDate = item.startDate
            table_data_item.endDate = item.endDate
            table_data_item.title = item.name
            table_data_item.type = item.type
            table_data_item.takeTime = item.takeTime
            table_data_item.disease = item.disease
            var itemArray = item.prescription
            for (var j = 0; j < item.prescription.length;j++){
                var itemJ = item.prescription[j]
                if(j%2 == 1){
                    itemArray[j-1].key1 = itemJ.key
                    itemArray[j-1].value1 = itemJ.value
                    itemArray[j-1].index1 = itemJ.index
                    itemArray[j-1].visible1 = false
                }else{
                  itemArray[j].visible = false
                }
            }
            var options = []
            for (var k = 0; k < itemArray.length;k++){
                if(k%2 == 0){
                    options.push(itemArray[k])
                }
            }
            table_data_item.options = options
            this.tablePrescription.push(table_data_item)
          }
          this.diagnoseResult = this.tablePrescription[0].disease
          this.takeMedTime = this.tablePrescription[0].takeTime
        }
    }
}
</script>

<style scoped>
table{
  border-collapse: collapse;
}
.container{
    width: 1160px;
    margin: auto auto;
    display: flex;
    flex-direction: column;
}
.container>img{
    width:109px;
    height: 139px;
    margin-top: 60px;
    margin-bottom: 30px;
    margin-left: auto;
    margin-right: auto;
}
.pay-success{
    font-size: 26px;
    color: #3E3A39;
    font-weight: bold;
}
.page-header{
    width: 1160px;
    margin-top: 30px;
    color: #333333;
    font-size: 20px;
}
.page-header >>> div{
    color:#333333;
    font-size: 20px;
}
.area-header-one{
    margin-top: 35px;
}
.basic-info{
    width: 986px;
    margin-top: 30px;
    margin-bottom: 15px;
}
.basic-info>li{
    color: #333333;
    font-size: 18px;
    text-align: left;
    line-height: 40px;
}
.basic-info>li>b{
    font-weight: bold;
}
.table-header{
    background: #156098;
    height: 70px;
    color: white;
}
.table-header>td{
    text-align: center;
    color: white;
    font-weight: bold;
    font-size: 18px;
}
.basic-table{
    margin-left: 35px;
}
.basic-table>td{
    height: 50px;
}
.table-rows>td{
    height: 50px;
    background: white;
    font-size: 18px;
}
.table-footer-td{
    height: 70px;
    background: white;
    font-size: 18px;
    background: #f9f9f9;
    text-align: left;
    padding-left: 30px;
}
.table-footer-td>b{
    font-size: 18px;
    color: red;
}
.td-total{
    text-align: center;
    height: 70px;
    background: white;
    font-size: 18px;
}
.td-amount{
    text-align: left;
    height: 70px;
    background: white;
    text-align: left;
    padding-left: 30px;
    font-size: 18px;
}
  .table-rows>td{
      height: 50px;
      background: white;
      font-size: 18px;
  }
.drug-weight{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.img-add-sub{
    width: 34px;
    height: 30px;
    position: relative;
    left: 220px;
}
.btn-confirm{
    width: 384px;
    border-radius: 40px;
    margin-top: 60px;
    margin-bottom: 60px;
    font-size: 18px;
    height: 45px;
    margin-left: auto;
    margin-right: auto;
}

.tabs{
    width: 100%;
    height: auto;
    margin-top: 20px;
    overflow-y: auto;
}
.item-row-center{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.item-row{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.item-column{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.list-span{
  height: 50px;
  width: 100%;
  color: #333;
  border-style: solid;
  border-color: #e6e6e6;
  border-bottom-width: 0.2px;
  text-align: center;
}
.radio{
  width: 100%;
  margin-bottom: 20px;
  margin-left: 0px;
  margin-right: 0px;
}
.span-index{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 25px;
  height: 25px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 50%;
  border-style: solid;
  border-color: red;
  border-width: 1px;
}
</style>
